export const privacyPolicydataCollection = [
  {
    data: "Name, employee ID, phone, email, role",
    purpose: "Sign-in and role-based access",
  },
  {
    data: "Precise location",
    purpose:
      "Verifying station visits, chlorination checks and complaint resolution at the point of submission",
  },
  {
    data: "Photos taken in-app",
    purpose:
      "Evidence of readings, station conditions, complaints, receipts, cylinder labels",
  },
  {
    data: "Files you attach",
    purpose: "Supporting documents for expense claims and job cards",
  },
  {
    data: "Device ID, app version, crash logs",
    purpose: "Security and app stability",
  },
  {
    data: "Work records you create",
    purpose: "Complaints, visits, cylinder movements, expenses",
  },
];

export const privacyPolicyretentionData = [
  { data: "Location logs", retention: "12 months" },
  { data: "Photos and evidence", retention: "24 months" },
  { data: "Complaint and visit records", retention: "36 months" },
  { data: "Expense records", retention: "7 years (statutory)" },
  { data: "Crash logs", retention: "90 days" },
];

export const privacyPolicyserviceProviders = [
  { name: "Cloud host", description: "hosting and storage" },
  { name: "Crash reporting", description: "diagnostics" },
  { name: "Push notifications", description: "task alerts" },
  { name: "Maps provider", description: "station locations" },
];

// Sections shown in the left-side aside. `id` must match the Section id below.
export const privacyPolicysections = [
  { id: "who-we-are", title: "Who we are" },
  { id: "data-we-collect", title: "Data we collect and why" },
  { id: "legal-basis", title: "Legal basis" },
  { id: "sharing", title: "Who we share it with" },
  { id: "retention", title: "How long we keep it" },
  { id: "deletion", title: "Account and data deletion" },
  { id: "security", title: "Security" },
  { id: "rights", title: "Your rights" },
  { id: "children", title: "Children" },
  { id: "changes", title: "Changes" },
];